
export enum StepKey {
  LOCATION = 'location',
  WELCOME = 'welcome',
  ATTITUDE = 'attitude',
  CRITERIA = 'criteria',
  CONTACT = 'contact',
  ANXIETY = 'anxiety',
  GENDER = 'gender',
  REASON = 'reason',
  REASON_DETAILS = 'reason_details',
  GOALS = 'goals',
  LAST_VISITED = 'last_visited',
  AVAILABILITY = 'availability',
  HOW_SOON = 'how_soon',
  INSURANCE = 'insurance',
  READY_TO_BOOK = 'ready_to_book',
}
